import { render } from "./TheCarTypeDetails.vue?vue&type=template&id=3c1a7d66"
import script from "./TheCarTypeDetails.vue?vue&type=script&lang=js"
export * from "./TheCarTypeDetails.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__